// extracted by mini-css-extract-plugin
export default {"container":"src-pages-SalesCannelVersion-SalesChannelDiscounts-Voucher-Detail-css-module__container--ixSo6"};